import { action } from 'satcheljs';

/**
 * This action will get dispatched when user saves the message list setting
 */
export const saveEventsAndInvitesOption = action('saveEventsAndInvitesOption');
